import DOMPurify from 'dompurify'
import { marked } from 'marked'

export default function markdownToHtmlConverter(markdownString) {
  return DOMPurify.sanitize(marked.parse(markdownString), {
    USE_PROFILES: { html: true },
  })
}
